'use client';

import type { FC } from 'react';

import { ProductBadge } from '@yanolja-rnd/nol-design-system';

export interface NotificationTickerProps {
  title?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * 위젯_공지
 *
 * @see {@link https://www.figma.com/design/zlHuiOHmYv1ghVDbTHUSvW/%5BGUIDE%5D-%EC%9C%84%EC%A0%AF%2F%EC%98%A4%EB%8D%94%EB%A7%81?node-id=4-14&node-type=canvas&t=OaPq9VxMsJp0eFnJ-0}
 */
export const NotificationTicker: FC<NotificationTickerProps> = ({ title, onClick }) => {
  if (!title) {
    return null;
  }

  return (
    <section className="w-full px-16 py-12 pc:w-pc-size pc:px-0 pc:py-16">
      <button
        className="flex items-center w-full gap-8 px-12 py-4 min-h-40 rounded-12 bg-fill-neutral-weak pc:min-h-48 pc:px-20"
        onClick={onClick}
        type="button"
      >
        <ProductBadge className="flex-shrink-0" radius="capsule">
          공지
        </ProductBadge>
        <span className="overflow-hidden typography-body-13-regular pc:typography-subtitle-16-regular truncate">
          {title}
        </span>
      </button>
    </section>
  );
};
